import matter from "gray-matter";
import privacy_en from "./en/privacy-policy.md";
import terms_conditions_en from "./en/terms-conditions.md";
import privacy_es from "./es/privacy-policy.md";
import terms_conditions_es from "./es/terms-conditions.md";

const LegalCollection = {
    en: [
        terms_conditions_en,
        privacy_en,
    ],
    es: [
        terms_conditions_es,
        privacy_es,
    ],
};

export function getLegalCollection(locale) {
    return LegalCollection[locale].map((file) => {
        return matter(file).data;
    })
    .filter((file) => file && Object.keys(file).length > 0);
}